import React, { useContext, useEffect, useState } from "react";
import IOrder from "../../../models/IOrder";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwDateInput from "../../shared/OwDateInput/OwDateInput";
import { Moment } from "moment-timezone";
import OwButton from "../../shared/OwButton/OwButton";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import { SocketContext } from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import { useFormik } from "formik";
import moment from "moment";
import IProcessDailyRouteDTO from "../../../models/DTO/IProcessDailyRouteDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnProcessDailyRouteDTO from "../../../models/DTO/IOnProcessDailyRouteDTO";
import INotification from "../../../models/INotification";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import IUiSocketSetup from "../../../models/IUiSocketSetup";

type Props = {
    orders: { guid: string; name: string; order: IOrder }[];
    cancelFn: (refresh?: boolean) => void;
};

interface IOrderRouteMap {
    [key: string]: IOrder[];
}

export const CreateDailyRouteFromOrdersSidebar = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const getOrderRouteMap = (): IOrderRouteMap => {
        const map: IOrderRouteMap = {};

        for (const orderDetail of props.orders) {
            const routeName = orderDetail.order.Route?.name || "";

            if (!map[routeName]) {
                map[routeName] = [];
            }

            if (map[routeName]) {
                map[routeName].push(orderDetail.order);
            }
        }

        return map;
    };

    const [isDisabled, setIsDisabled] = useState(true);
    const [orderRouteMap, setOrderRouteMap] = useState<IOrderRouteMap>(getOrderRouteMap());

    const cancel = () => {
        props.cancelFn();
    };

    const processDailyRoute = (values: { route_date: string }) => {
        const dailyRoutes = Object.keys(orderRouteMap).map((routeName) => {
            return {
                dailyRoute: {
                    route_date: values.route_date,
                    route_id: orderRouteMap[routeName][0].route_id,
                },
                orders: orderRouteMap[routeName].map((order) => order.id),
            };
        });

        const payload: IProcessDailyRouteDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            dailyRoutes,
        };

        socket.emit(EndpointsEnum.RoutesProcessDailyRoute, payload);
    };

    const onProcessDailyRoute = (data: IOnProcessDailyRouteDTO) => {
        const notification: INotification = {
            message: "successfully_processed_new_daily_routes",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        uiContext.notifyFn(null, notification);

        props.cancelFn(true);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.RoutesOnProcessDailyRoute, fn: onProcessDailyRoute }];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const formik = useFormik({
        initialValues: {
            route_date: moment().format("YYYY-MM-DD"),
        },
        onSubmit: (values) => {
            // props.getTransportOptions(values);
            processDailyRoute(values);
        },
        validate: (values) => {
            const errors: any = {};

            if (!values.route_date) {
                errors.route_date = "Required";
            }
            //
            // if (!values.route_id) {
            //     errors.route_id = "Required";
            // }

            setIsDisabled(Object.keys(errors).length > 0);

            return errors;
        },
    });

    return (
        <div className={"CreateDailyRouteFromOrdersSidebar p-2"}>
            <div className={"row"}>
                <div className={"col-12"}>
                    <div className="text-end">
                        <button className="btn btn-danger btn-sm" onClick={cancel}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} leftIconName={"fad fa-truck-front"} title={"create_daily_route"} />
                    <hr />
                </div>
            </div>

            <div className="row">
                <form onSubmit={formik.handleSubmit}>
                    <div>
                        <div>
                            <OwLabel title={"route_date"} />
                        </div>
                        <div>
                            <OwDateInput
                                selectedDate={formik.values.route_date}
                                fn={(date: Moment) => {
                                    const e = {
                                        target: {
                                            value: date.format("YYYY-MM-DD"),
                                            name: "route_date",
                                        },
                                    };

                                    formik.handleChange(e);
                                }}
                            />
                        </div>
                    </div>
                    <div className={"d-flex flex-column mb-4"}>
                        <div className={""}>
                            {Object.keys(orderRouteMap).map((routeName) => {
                                return (
                                    <div key={routeName}>
                                        <OwLabel title={routeName} isBold={true} skipTranslate={true} />
                                        {orderRouteMap[routeName].map((order) => {
                                            return (
                                                <div key={order.guid}>
                                                    <div className={"d-flex"}>
                                                        <div className={"flex-grow-1"}>{order.name}</div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div>
                        <OwButton type={"submit"} title={"save"} disableOnActive={true} disabled={isDisabled} />
                    </div>
                </form>
            </div>
        </div>
    );
};
